import { callApi as callOnboardingApi } from "../components/newOnboarding/lib/api";
import { persistAuthSession, type ApiLoginUser } from "./authSession";

type LoginPayload = {
  email: string;
  password: string;
  headers?: Record<string, string>;
};

type LoginResponse = {
  token: string;
  user: ApiLoginUser;
};

export async function loginAndPersistSession({
  email,
  password,
  headers,
}: LoginPayload) {
  const data = (await callOnboardingApi("/user/login", {
    method: "POST",
    data: { email, password },
    headers,
  })) as LoginResponse;
  persistAuthSession(data.token || "", data.user, email);
  return data;
}
